<template>
  <tr
      :style="getColor"
  >
    <td v-if="number_rows" class="text-xxs">
      {{i + number_rows}}
    </td>
    <td
        v-for="(col, tdi) in columns"
        :key = tdi
        class="text-xs text-center-light"
        :class="typeof col?.td_class === 'function' ? col?.td_class(tr) : col?.td_class "
        :style="typeof col?.td_style === 'function' ? col?.td_style(tr) : col?.td_style"
    >
      <input class="ms-1" v-if="col?.checkbox" type="checkbox" :value="getCheckboxValue(tr, col)" v-model="chartLines" />

      <!--          <span  v-if = "col?.type === 'bool'">-->
      <!--            <span v-if = "tr[col.prop]" class="badge badge-sm bg-gradient-success">{{$t(col?.text_true)}}</span>-->
      <!--            <span v-if = "!tr[col.prop]" class="badge badge-sm bg-gradient-danger">{{$t(col?.text_false)}}</span>-->
      <!--          </span>-->
      <!--          <div v-if="col?.buttons">-->
      <span
          v-for="(button, n_b) in col?.buttons"
          :key = "i + 'b' + n_b"
      >
            <button
                v-if="button.if_callback === undefined || button.if_callback(tr)"
                @click = "button.click(tr, button)"
                v-html="handlerForHtmlButton(tr, button)"
                class="btn btn-sm p-2 py-1 m-0 mx-1"
                :class="button?.class"
                :title="button?.title ?? null"
                data-bs-toggle="tooltip"
            ></button>

<!--            <span v-if="button?.name && tr?.button && tr?.button[button?.name] !== undefined && tr?.button[button?.name]?.loading ">1</span>-->
          </span>

      <!--          </div>-->

      <i v-if="$store.state.init.current_bot.tariff !== 1 && col?.allow_tariff > $store.state.init.current_bot.tariff" class="fas fa-star" style="color: #5858e0;"></i>
      <span v-else>
            <span v-if="col?.foo" v-html="reduction(col, col.foo(tr[col.prop], tr))" :class="col?.item_class" @click="() => { if (col?.click) { col.click(tr) } else { return false } }"></span>

            <span v-else :class="col?.item_class" @click="() => { if (col?.click) { col.click(tr) } else { return false } }">
                {{reduction(col, tr[col?.prop]) ?? col?.empty}} {{col?.unit ?? ''}}
              <span v-if="col?.add_prop && tr[col.add_prop] && tr[col.prop] !== tr[col.add_prop]" class="badge bg-info ms-2">{{tr[col.add_prop]}}</span>
            </span>
          </span>

    </td>
  </tr>

  <child_tr
      v-for="(tr_child, ic) in tr?.children"
      :key = ic
      :tr = tr_child
      :columns = columns
      :number_rows = number_rows
  ></child_tr>
</template>

<script>

export default {
  name: "child_tr",
  props: {
    tr: {
      type: Object,
      default: null,
    },
    columns: {
      type: Array,
      default: null,
    },
    i: {
      type: Number,
      default: 0,
    },
    number_rows: {
      type: Number,
      default: 0,
    },
    // row_checkboxes: {
    //   type: Object,
    //   default: null,
    // },
  },
  data: function () {
    return {
      nameLine: null
    }
  },
  // emits: ['update:row_checkboxes'],
  computed: {
    chartLines: {
      get() {
        return this.$store.state.report.lines
      },
      set(newLinesList) {

        let action = null
        let nameElem = null
        if (newLinesList.length > this.$store.state.report.lines.length) {
          nameElem = newLinesList.filter(item => !this.$store.state.report.lines.includes(item));
          action = 'add'
        } else {
          nameElem = this.$store.state.report.lines.filter(item => !newLinesList.includes(item));
          action = 'remove'
        }

        if (action === 'add') {
          this.nameLine = nameElem[0]
          this.$store.dispatch('report/getColor', nameElem[0])
          this.$store.commit('report/addLinesAdditionalData', { name: nameElem[0], data: JSON.parse(JSON.stringify(this.tr)) })
        }

        this.$store.commit('report/__set', { name: 'lines', val:newLinesList })
        this.$store.commit('report/runLinesMutation',  { action: action, name: nameElem[0]})
        // this.$emit('update:row_checkboxes', value)
      }
    },
    getColor: function () {
      if (this.$store.state.report.colorLines[this.nameLine] !== null) {
        return 'border-left: 3px solid ' + this.$store.state.report.colorLines[this.nameLine]
      }
      return ''
    }
  },
  methods: {
    // дублируется функция в родителе
    getCheckboxValue: function(tr, col) {
      if (col?.checkbox?.type === 'int') {
        return this.nameLine = parseInt( tr[col?.checkbox.prop])
      }

      if (Array.isArray(tr[col?.checkbox.prop])) {
        return  this.nameLine = tr[col?.checkbox.prop].join(',')
      }
      return this.nameLine = tr[col?.checkbox.prop]
    },
    reduction: function(col, val){
      if (col?.replaceSomeData && col?.replaceSomeData[val] !== undefined) {
        return col?.replaceSomeData[val]
      }
      if (val === null) {
        return null
      }

      if ((typeof val !== "number" && col?.type_data !== "number") || col?.reduction === false || val < 1000) {
        return val
      }
      val = val / 1000
      return val.toFixed(2) + 'k'
    },
    handlerForHtmlButton(tr, button) {
      if (button?.name && tr?.button && tr?.button[button?.name] !== undefined && tr?.button[button?.name]?.loading ) {
        return '<div class="spinner-grow w-10px h-10px text-white" role="status"><span class="sr-only">Loading...</span></div>'
      }
      return typeof button.label === 'function' ? button.label(tr) : button.label
    }
  }
}
</script>

<style scoped>

</style>